import api from "@/lib/api";

// Ürün dizini: tek seferde indirilir, bellekte tutulur → arama tarayıcıda ANLIK yapılır (sunucuya her tuşta istek yok)
const TTL = 3 * 60 * 1000;
let cache = null, loadedAt = 0, inflight = null;

const TR = { "ı": "i", "İ": "i", "I": "i", "ş": "s", "Ş": "s", "ğ": "g", "Ğ": "g", "ü": "u", "Ü": "u", "ö": "o", "Ö": "o", "ç": "c", "Ç": "c" };
export const fold = (s) => String(s || "").replace(/[ıİIşŞğĞüÜöÖçÇ]/g, (ch) => TR[ch]).toLowerCase();
// Kelime tabanlı, Türkçe/boşluk duyarsız eşleşme: her kelime alanlardan birinde geçmeli (sıra önemsiz)
export const matchesSearch = (q, ...fields) => {
  const terms = fold(q).split(/\s+/).filter(Boolean);
  if (!terms.length) return true;
  const hay = fold(fields.filter(Boolean).join(" "));
  return terms.every((t) => hay.includes(t));
};

const prep = (p) => {
  const s = fold([p.name, p.code, p.barcode, ...(p.barcodes || []), p.brand, p.series, p.category, p.discount_group].filter(Boolean).join(" "));
  return { ...p, _s: s, _sns: s.replace(/\s+/g, ""), _code: fold(p.code), _bar: fold(p.barcode), _name: fold(p.name) };
};

export async function getProductIndex(force = false) {
  if (cache && !force && Date.now() - loadedAt < TTL) return cache;
  if (inflight) return cache && !force ? cache : inflight;
  inflight = api.get("/products/index").then((r) => { cache = (r.data || []).map(prep); loadedAt = Date.now(); return cache; }).finally(() => { inflight = null; });
  return cache && !force ? cache : inflight;   // eski dizin varsa hemen onu ver, arka planda yenile
}
export const invalidateProductIndex = () => { cache = null; loadedAt = 0; };
// Açılışta eski dizin anında gösterilir; 10 sn'den eskiyse arka planda yenilenip liste güncellenir (yeni eklenen ürün hemen görünür)
export function refreshProductIndex(onUpdate) {
  if (!cache || Date.now() - loadedAt < 10000) return;
  getProductIndex(true).then((list) => onUpdate && onUpdate(list)).catch(() => {});
}

// Kelime tabanlı, Türkçe duyarsız arama + marka/seri/kategori filtresi; skor: kod/barkod tam eşleşme > ad başlangıcı > diğer
export function searchProducts(list, q, filters = {}, limit = 300) {
  const terms = fold(q).split(/\s+/).filter(Boolean);
  const { brand, series, category } = filters;
  const full = terms.join(" ");
  const out = [];
  for (const p of list) {
    if (brand && p.brand !== brand) continue;
    if (series && p.series !== series && p.discount_group !== series) continue;
    if (category && p.category !== category) continue;
    let ok = true;
    // Boşluk-duyarsız: "1x16" araması "1x 16" ürününü de bulur (_sns = boşluksuz)
    for (const t of terms) { const tns = t.replace(/\s+/g, ""); if (!p._s.includes(t) && !(tns && p._sns.includes(tns))) { ok = false; break; } }
    if (!ok) continue;
    let score = 0;
    if (terms.length) {
      if (p._code === full || p._bar === full) score = 5;
      else if (p._name === full) score = 4;
      else if (p._name.startsWith(full) || p._code.startsWith(full)) score = 3;
      else if (terms.every((t) => (" " + p._name).includes(" " + t))) score = 2;   // her kelime sözcük başında
      else if (p._name.includes(full)) score = 1;
    }
    out.push([Number(p.quantity) > 0 ? 1 : 0, score, Number(p.quantity) || 0, p]);
  }
  // STOKLU en üstte → metne EN YAKIN (skor) → eşit yakınlıkta EN ÇOK STOKLU → ada göre (kullanıcı isteği)
  out.sort((a, b) => b[0] - a[0] || b[1] - a[1] || b[2] - a[2] || a[3]._name.localeCompare(b[3]._name, "tr"));
  return out.slice(0, limit).map((x) => x[3]);
}
